import '../App.css';
import './ContentView.css';
import './ImageOverlay.css';

// Image component to display an image along with its creator

function Image({ className, img, alt, onClick, isOverlay = false }) {
    const baseUrl = `${process.env.REACT_APP_API_BASE_URL}`;

    return (
        <div className={isOverlay ? "OverlayImageContainer" : "DefaultImgWrapper"}>
            <img
                className={className}
                src={ img?.image?.url ? `${baseUrl}${img.image.url}` : '' }
                alt={alt}
                onClick={onClick}
            />
            <div className="ImageCredit">
                Foto:&nbsp;
                {img.link ? (
                    <a href={img.link} target="_blank" rel="noopener noreferrer">{img.creator}</a>
                ) : img.creator}
            </div>
        </div>
    );
}

export default Image;